import React from 'react';

import { useReactNodeView } from '@lyearn/lygo-core';

import WebBookmarkComponentEditable from './WebBookmarkEditable';
import WebBookmarkComponentReadOnly from './WebBookmarkReadOnly';

const WebbookmarkNodeView: React.FC = () => {
  const { node, view } = useReactNodeView();

  if (!view?.editable) {
    return <WebBookmarkComponentReadOnly {...node?.attrs} />;
  }

  return <WebBookmarkComponentEditable {...node?.attrs} />;
};

export default WebbookmarkNodeView;
